import React from 'react'
import StatusTable from '../StatusTable'

export default function RegionStatus() {
  const tableData = (item) => {
    return [{ value: item.regionCode }, { value: item.name }, { value: item.remark ? item.remark : '-----' }, { type: 'STATUS_ENUM', status: item.status }]
  }
  return <StatusTable key="Region" tableData={tableData} module="REGION" />
}
